/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPhysicianPage } from './HchbPhysicianPage';
import {
    HchbPhysicianPageFromJSON,
    HchbPhysicianPageFromJSONTyped,
    HchbPhysicianPageToJSON,
    HchbPhysicianPageToJSONTyped,
} from './HchbPhysicianPage';

/**
 * 
 * @export
 * @interface FindAllHchbPhysicians200Response
 */
export interface FindAllHchbPhysicians200Response {
    /**
     * 
     * @type {HchbPhysicianPage}
     * @memberof FindAllHchbPhysicians200Response
     */
    data?: HchbPhysicianPage;
}

/**
 * Check if a given object implements the FindAllHchbPhysicians200Response interface.
 */
export function instanceOfFindAllHchbPhysicians200Response(value: object): value is FindAllHchbPhysicians200Response {
    return true;
}

export function FindAllHchbPhysicians200ResponseFromJSON(json: any): FindAllHchbPhysicians200Response {
    return FindAllHchbPhysicians200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPhysicians200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPhysicians200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPhysicianPageFromJSON(json['data']),
    };
}

export function FindAllHchbPhysicians200ResponseToJSON(json: any): FindAllHchbPhysicians200Response {
    return FindAllHchbPhysicians200ResponseToJSONTyped(json, false);
}

export function FindAllHchbPhysicians200ResponseToJSONTyped(value?: FindAllHchbPhysicians200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPhysicianPageToJSON(value['data']),
    };
}

